import { defaultBrandSettings } from 'modules/white-label/constants/brand-settings'
import { sanitizeHostname } from './sanitize-hostname'

const getReferenceHostname = () => {
  const envHostname = sanitizeHostname(process.env.NEXT_PUBLIC_SIO_HOSTNAME)

  if (envHostname) {
    return envHostname
  }

  return sanitizeHostname(defaultBrandSettings.dashboardHostname)
}

const resolveHostname = (hostname?: string) =>
  sanitizeHostname(
    hostname ?? (typeof window !== 'undefined' ? window.location.hostname : undefined),
  )

export const isSioDomain = (hostname?: string) => {
  const referenceHostname = getReferenceHostname()

  if (!referenceHostname) {
    return false
  }

  return resolveHostname(hostname) === referenceHostname
}
